module.exports = __webpack_public_path__ + "img/login_panel.9369dbb1.png";